import { GridEditCellProps } from '@mui/x-data-grid-pro';
import React from 'react';
import { AudienceEditTimeModal } from '../modals/AudienceEditTimeModal';
import { isNumber } from 'lib/typeguards';
import { Box } from '@mui/material';
import { getSecondsToExpiryComponents } from 'lib/timeHelpers';

const AudienceEditTimeInput: React.FC<GridEditCellProps> = ({ value, api, id, field }) => {
    const initialData = React.useMemo(
        () => (isNumber(value) ? getSecondsToExpiryComponents(value) : undefined),
        [value]
    );
    const handleSubmit = React.useCallback(
        (time?: number) => {
            if (value !== time) {
                if (isNumber(time)) {
                    api.setEditCellValue({ id, field, value: time });
                } else {
                    api.setEditCellValue({ id, field, value: '' });
                }
                api.stopCellEditMode({ id, field });
            }
        },
        [api, field, id, value]
    );
    const handleClose = React.useCallback(() => {
        api.stopCellEditMode({ id, field });
    }, [api, field, id]);
    return (
        <React.Fragment>
            <Box>Editing...</Box>
            <AudienceEditTimeModal
                open
                onClose={handleClose}
                onSubmit={handleSubmit}
                initialData={initialData}
            />
        </React.Fragment>
    );
};

export const AudienceEditTimeInputCell = (props: GridEditCellProps) => <AudienceEditTimeInput {...props} />;
